export const subscriptionReport = [];

export const revenueReport = [];

export const durationOptions = [
  'This Month',
  'Last 3 Months',
  'Last 6 Months',
  'This Year',
];

export { formatPlatformPrice as formatPrice } from '../../../utils/platformMoney';
